import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2 py-0.5 text-[10.5px] font-bold tracking-[1.5px] uppercase transition-colors focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-gold text-ink',
        gold: 'border-transparent bg-gold-a12 text-gold2',
        ember: 'border-transparent bg-ember-a14 text-[#FFB08A]',
        secondary: 'border-hair bg-glass-2 text-mut',
        outline: 'border-hair text-txt',
        good: 'border-transparent bg-good/15 text-good',
        bad: 'border-transparent bg-bad/15 text-bad',
      },
    },
    defaultVariants: {
      variant: 'gold',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
